exports.components = {
  "component---src-layouts-home-js": () => import("./../../../src/layouts/home.js" /* webpackChunkName: "component---src-layouts-home-js" */),
  "component---src-layouts-portfolio-js": () => import("./../../../src/layouts/portfolio.js" /* webpackChunkName: "component---src-layouts-portfolio-js" */),
  "component---src-layouts-text-page-js": () => import("./../../../src/layouts/textPage.js" /* webpackChunkName: "component---src-layouts-text-page-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

